import request from '@/helper/request'
import {formatTime} from "@/helper/formatTime";

const URL = {
  GET: '/notes/trash',
  REVERT: '/notes/:noteId/revert',
  DELETE: '/notes/:noteId/confirm'
}

export default {
  getAll() {
    return new Promise((resolve, reject) => {
      request(URL.GET)
        .then(res => {

          res.data.forEach(note=>{
            note.createTimeformat = formatTime(note.createdAt)
            note.updateTimeformat = formatTime(note.updatedAt)
          })
          res.data = res.data.sort((note1, note2) => note1.createdAt < note2.createdAt)

          resolve(res)
        }).catch(err => {
          reject(err)
        })
    })
  },

  deleteNote({ noteId }) {
    return request(URL.DELETE.replace(':noteId', noteId), 'DELETE')
  },

  revertNote({ noteId }) {
    return request(URL.REVERT.replace(':noteId', noteId), 'PATCH')
  }

}
